import { render, staticRenderFns } from "./ProdutoCotaDepartamento.vue?vue&type=template&id=7bdc5e8c"
import script from "./ProdutoCotaDepartamento.vue?vue&type=script&lang=js"
export * from "./ProdutoCotaDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports